import {
  ChakraBox,
  ChakraFlex,
  EquipUIFireflyV2Theme,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

const { success, critical, neutral } = EquipUIFireflyV2Theme.colors;

type StatusRowProps = {
  label: string;
  value: string | number;
  valueColor?: string;
  hasBorder?: boolean;
};

const StatusRow = ({
  label,
  value,
  valueColor,
  hasBorder = true,
}: StatusRowProps) => (
  <ChakraFlex
    alignItems="center"
    borderBottom={hasBorder ? '1px solid' : undefined}
    borderColor={hasBorder ? 'neutral.border.secondary' : undefined}
    justifyContent="space-between"
    paddingBottom="12px"
    paddingTop="12px"
  >
    <Text color="neutral.secondary" variant="body">
      {label}
    </Text>
    <Text color={valueColor} variant="body">
      {value}
    </Text>
  </ChakraFlex>
);

type JobStatusModalProps = {
  topLevelId: string;
  isOpen: boolean;
  onClose: () => void;
  jobStatus: OpsBulkJobStatusResponse | null;
};

const JobStatusModal = ({
  topLevelId,
  isOpen,
  onClose,
  jobStatus,
}: JobStatusModalProps) => {
  return (
    <ModalV2
      id={`${topLevelId}-status-modal`}
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      title="Job Status"
    >
      {jobStatus && (
        <ChakraBox>
          <StatusRow label="Job ID:" value={jobStatus.jobId} />
          <StatusRow label="Job Key:" value={jobStatus.jobKey} />
          <StatusRow label="Job Status:" value={jobStatus.jobStatus} />
          <StatusRow
            label="Total Patients:"
            value={jobStatus.patientData.totalPatients}
          />

          <ChakraBox height="12px" />

          <StatusRow
            label="Patients Succeeded:"
            value={jobStatus.patientData.success}
            valueColor={success.base}
          />
          <StatusRow
            label="Patients In Progress:"
            value={jobStatus.patientData.inProgress}
            valueColor={neutral.primary}
          />
          <StatusRow
            label="Patients Failed:"
            value={jobStatus.patientData.failure}
            valueColor={critical.base}
          />
          <StatusRow
            label="Patients Skipped:"
            value={jobStatus.patientData.skipped}
            valueColor={neutral.primary}
            hasBorder={false}
          />

          <ChakraBox marginTop="24px">
            <FireflyButton
              id={`${topLevelId}-close-modal`}
              onClick={onClose}
              width="100%"
            >
              Close
            </FireflyButton>
          </ChakraBox>
        </ChakraBox>
      )}
    </ModalV2>
  );
};

export default JobStatusModal;
